import { useTheme } from '@mui/material';
import { Logout } from 'iconsax-react';
import { type FC, useCallback } from 'react';

import { useSlabAuth } from '../../hooks/useSlabAuth';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from './styles';

interface AppLogoutProps {
  isOpen: boolean;
}

const AppLogout: FC<AppLogoutProps> = ({ isOpen }) => {
  const theme = useTheme();
  const { logout } = useSlabAuth();

  const logoutHandler = useCallback(() => {
    logout();
  }, [logout]);

  return (
    <ListItem disablePadding>
      <ListItemButton onClick={logoutHandler} isOpen={isOpen}>
        <ListItemIcon>
          <Logout color={theme.palette.SlabGray['500']} />
        </ListItemIcon>
        <ListItemText isOpen={isOpen} primary='Log Out' />
      </ListItemButton>
    </ListItem>
  );
};

export default AppLogout;
